import React, { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { Typography, Box, Container } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import parse from "html-react-parser"
import { useTheme } from "@emotion/react";

export default function PreviewPage({ page_id, preview_id }) {

	const theme = useTheme();
	const [page, setPage] = useState();

	//if draft preview page
	const { data: preview } = useQuery({
		queryKey: ['page', page_id],
		queryFn: () => axios.get(`${WP_API_Settings.endpoint}wp/v2/pages/${page_id}?_embed&preview=true`, {
			headers: {
				'X-WP-Nonce': WP_API_Settings.nonce
			}
		}),
		retry: 1,
		enabled: !!page_id
	})

	//if revision preview page
	const { data: revision } = useQuery({
		queryKey: ['page', preview_id],
		queryFn: () => axios.get(`${WP_API_Settings.endpoint}wp/v2/pages/${preview_id}/revisions?_embed&preview=true`, {
			headers: {
				'X-WP-Nonce': WP_API_Settings.nonce
			}
		}),
		retry: 1,
		enabled: !!preview_id
	})

	//set the page data
	useEffect(() => {
		if (preview?.data) {
			setPage(preview?.data);
		} else if (revision?.data) {
			setPage(revision?.data[0]);
		}
	}, [preview, revision])

	return (
		<Container maxWidth={theme.global.container}>
			<Grid>
				<Typography variant='h1' component='h1'>
					{page?.title.rendered}
				</Typography>
				<article id={page?.id}>
					{page?.content?.rendered ? parse(page?.content?.rendered) : null}
				</article>
			</Grid>
		</Container>
	)
}